import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { TableModule } from 'primeng/table';
import { InputMaskModule } from 'primeng/inputmask';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TooltipModule } from 'primeng/tooltip';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

import { AuthService } from 'src/app/core/auth/auth.service';
import { NotificationsService } from 'src/app/shared/notifications/notifications.service';
import { AuthorizationGuard } from 'src/app/core/guards/authorization.guard';
import { NotificationsModule } from 'src/app/shared/notifications/notifications.module';


import { LoaderModule } from 'src/app/shared/components/loader/loader.module';

import { CheckboxModule } from 'primeng/checkbox';
import { TabViewModule } from 'primeng/tabview';

import { TimelineModule } from 'primeng/timeline';

import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';

import { CardModule } from 'primeng/card';
import { DialogModule } from 'primeng/dialog';
import { ScUserService } from 'src/app/core/services/sc/sc-user.service';

import { SfSubHeaderModule } from 'src/app/shared/components/sub-header/sub-header.module';
import { SfBreadCrumbModule } from 'src/app/shared/components/sf-breadcrumb/sf-breadcrumb.module';
import { DividerModule } from 'primeng/divider';
import { DropdownModule } from 'primeng/dropdown';
import { InputNumberModule } from 'primeng/inputnumber';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { SharedModule } from 'src/app/shared/shared.module';
import { SfDropDownModule } from 'src/app/shared/components/dropdown/dropdown.module';
import { ScUserMessageListComponent } from './sc-user-message-list/sc-user-message-list.component';
import { ScUserRoutingModule } from './sc-user-message.routing.module';
import { ScUserMessageSendComponent } from './sc-user-message-send/sc-user-message-send.component';
import { ScUserMessageChatComponent } from './sc-user-message-chat/sc-user-message-chat.component';
import { DataViewModule } from 'primeng/dataview';

registerLocaleData(localePT, 'pt', localeExtraPT);

@NgModule({
    declarations: [ScUserMessageListComponent, ScUserMessageSendComponent, ScUserMessageChatComponent],
    exports: [ScUserMessageListComponent, ScUserMessageSendComponent, ScUserMessageChatComponent],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        ButtonModule,
        InputTextModule,
        InputMaskModule,
        CheckboxModule,
        TranslateModule,
        MessageModule,
        MessagesModule,
        TableModule,
        TooltipModule,
        ConfirmDialogModule,
        LoaderModule,
        CardModule,
        DialogModule,
        NotificationsModule,
        DropdownModule,
        InputNumberModule,
        InputTextModule,
        ScrollPanelModule,
        TimelineModule,
        DividerModule,
        SharedModule,
        SfBreadCrumbModule,
        SfSubHeaderModule,
        SfDropDownModule,
        TabViewModule,
        ScUserRoutingModule,
        DataViewModule
    ],
    providers: [NotificationsService, AuthService, AuthorizationGuard, ScUserService, { provide: LOCALE_ID, useValue: 'pt' }]
})
export class ScUserMessageModule { }